import {post,get} from '../libs/ajax.js'
export * from './baseInfo/app'
export * from './queue.js'
export * from './tool_config.js'
export * from './efficiencyTool/ads.js'
export * from './dataCenter/material.js'
export * from './marketManage/earlyWarn.js'
export * from './marketManage/configuration.js'
export * from './marketManage/huaweiAds.js'
export * from './marketManage/honor.js'
/**
 * 获取 腾讯cos 配置
 * @param {*} data
 * @returns
 */
export function getCosConfig(data) {
    return post('/get_upload_conf', data)
}
// 获取 云的基础信息配置
export function getCosConfigBase(data) {
    return get('/get_bucket_info', data)
}

/**
 * 获取模块接口
 * @returns
 */
export function getBaseModulesApi() {
    return get('/treatment/get_modules')
}